import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { OrganizationType, SessionResponse, UserType } from '@/types/session';
import { getRealm } from '@/utils/realmCookie';

interface AuthState {
  session: SessionResponse | null;
  setSession: (session: SessionResponse) => void;
  clearSession: () => void;

  organizationType: OrganizationType | null;
  userType: UserType | null;
  permissions: string[];
  hasPermission: (code: string) => boolean;

  /** True when the current session is an entity impersonation session. */
  isEntitySession: boolean;

  /** Tenant realm from the workpay_realm cookie — read once at store creation. */
  realm: string | null;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    (set, get) => ({
      session: null,
      organizationType: null,
      userType: null,
      permissions: [],
      isEntitySession: false,
      realm: getRealm(),

      setSession: (session) => {
        set({
          session,
          organizationType: session.organization.type,
          userType: session.user.type,
          permissions: session.user.permissions,
          isEntitySession: session.isEntitySession ?? false,
        });
      },

      clearSession: () =>
        set({
          session: null,
          organizationType: null,
          userType: null,
          permissions: [],
          isEntitySession: false,
        }),

      hasPermission: (code: string) => get().permissions.includes(code),
    }),
    { name: 'auth-store' },
  ),
);
